/**
 * DAB-33 Limited products
 **/
'use strict';

var isBigVolume = JSON.parse($('#isBigVolume').val()) || false;
var basketHasBigVolumeInside =
    JSON.parse($('#basketHasBigVolumeInside').val()) || false;
var basketHasNormalVolumeInside =
    JSON.parse($('#basketHasNormalVolumeInside').val()) || false;

var hasClickAndCollectOnCart = JSON.parse($('#hasClickAndCollect').val()) || false;
var hasMoreClickAndCollectEnabled = JSON.parse($('#MoreClickAndCollectEnabled').val()) || false;

var minicartQuantity = $('.minicart-quantity:first').text();
var minicartQuantityToNumber = parseInt(minicartQuantity, 10);
const { clickAndCollectFunctions } = require('./helpers');

function validateNormalProductInsideCart() {
    $('[click-and-collect-modals]').prop('disabled', true);
    $('[click-and-collect-modals]').on('mouseenter', function () {
        if (!$(this).attr('data-cc-in-cart') === true) {
            $('.tooltip-clickandcollect.two').css({ display: 'block' });
        }
    });
    $('[click-and-collect-modals]').on('mouseleave', function () {
        if (!$(this).attr('data-cc-in-cart') === true) {
            $('.tooltip-clickandcollect.two').css({ display: 'none' });
        }
    });
}

function validatePersonalizationWithClickandCollect() {
    $('.summary-confirm').on('click', function () {
        setTimeout(() => {
            if (localStorage && Object.keys(localStorage).some(key => key.includes('_personalizationsData'))) {
                $('[click-and-collect-modals]').prop('disabled', true);
                $('[click-and-collect-modals]').on('mouseenter', function () {
                    $('.tooltip-clickandcollect.three').css({ display: 'block' });
                });
                $('[click-and-collect-modals]').on('mouseleave', function () {
                    $('.tooltip-clickandcollect.three').css({ display: 'none' });
                });
            }
        }, 200);
        $('.personalization-reset-btn, .personalization-reset-btn-PDP').on('click', function () {
            $('.tooltip-clickandcollect.three').addClass('d-none');
        });
    });
}

function onInitClickAndCollectProductValidation() {
    $(document).ready(function () {
        if (
            (isBigVolume && basketHasBigVolumeInside) ||
            (isBigVolume && basketHasNormalVolumeInside) ||
            (!isBigVolume && basketHasBigVolumeInside)
        ) {
            return;
        } else if (hasClickAndCollectOnCart && hasMoreClickAndCollectEnabled) {
            clickAndCollectFunctions();
        } else if (minicartQuantityToNumber > 0 && !hasClickAndCollectOnCart) {
            validateNormalProductInsideCart();
        }
        validatePersonalizationWithClickandCollect();
    });

    $('#btn-add-to-cart').on('click', function () {
        validateNormalProductInsideCart();
    });
}

module.exports = {
    onInitClickAndCollectProductValidation: onInitClickAndCollectProductValidation
};
